import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-form-heading',
  templateUrl: './form-heading.component.html',
  styleUrls: ['./form-heading.component.scss'],
})
export class FormHeadingComponent {
  @Input() formTitle = 'Lorem ipsum';
  @Input() formLead: string | null | undefined = this.translate.instant('formErrors.required.all');

  constructor(private readonly translate: TranslateService) {}
}
